"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CROSS_NEED_MAX_SEARCHED_NEEDS = void 0;
exports.CROSS_NEED_MAX_SEARCHED_NEEDS = 50;
